import type { AuthOperationErrorCode } from "@/domain/errorCodes";
import type { IAuthenticationService } from "@/application/ports/services";

export class ResetPasswordUseCase {
  constructor(private authService: IAuthenticationService) {}

  async execute(
    token: string,
    newPassword: string,
  ): Promise<{ success: boolean; error?: AuthOperationErrorCode }> {
    return this.authService.resetPassword(token, newPassword);
  }
}
